const SDK_ELEMENT_ID = 'facebook-jssdk'
const SDK_SRC_URL = 'https://connect.facebook.net/pl_PL/sdk.js'
const SDK_GRAPH_API_VERSION = 'v2.11'

export default class FacebookService {
  /**
   * 
   * @param {Object} loginConfig 
   */
  constructor (loginConfig) {
    this.loginConfig = loginConfig
  
    this.prepareUserData = this.prepareUserData.bind(this)
    this.login = this.login.bind(this)
  }

  loadSdk () {
    return new Promise(resolve => {
      const s = 'script'
      const fjs = document.getElementsByTagName(s)[0]
      
      if (document.getElementById(SDK_ELEMENT_ID)) {
        resolve('SDK loaded')
        return
      }
      
      const js = document.createElement(s)
      js.id = SDK_ELEMENT_ID
      js.src = SDK_SRC_URL
      fjs.parentNode.insertBefore(js, fjs)

      resolve('SDK loaded')
    })
  }

  initFacebookApi = () => {
    window.fbAsyncInit = () => {
      FB.init({
        appId: this.loginConfig.appID,
        cookie: false,
        status: true,
        xfbml: true, // Parse social plugins on this page
        version: SDK_GRAPH_API_VERSION, // Use graph api version 2.11
      })

      this.checkLoginState()
        .then(response => this.attachEventToButton(response))
        .catch(log.error)
    }
  }

  isFacebookApiLoaded = () => document.getElementById(SDK_ELEMENT_ID)

  init () {
    if (!this.isFacebookApiLoaded()) {
      return this.loadSdk()
        .then(this.initFacebookApi)
        .catch(log.error)
    }

    log.debug('::::::: FB APP INIT :::::::')
    return Promise.resolve().then(this.initFacebookApi)
  }

  checkLoginState () {
    return new Promise((resolve, reject) => {
      FB.getLoginStatus(function(response) {
        if (response) resolve(response)
        reject('Error occured during checking login status')
      })
    })
  }

  /**
   * Attach click event depends on response status
   * 
   * @param {Object} response 
   */
  attachEventToButton (response) {
    const loginButtons = this.loginConfig.loginButtons
    const prepareUserData = this.prepareUserData
    const fbLogin = this.login

    loginButtons.forEach(button => {
      if (response.status === 'connected') {
        // Logged into app and Facebook.
        button.addEventListener('click', prepareUserData)
      } else {
        // Log into the facebook account and proceed
        button.addEventListener('click', fbLogin)
      }
    })
  }

  login () {
    FB.login(response => {
      response.authResponse ? this.prepareUserData() : null
    }, {
      scope: 'public_profile,email',
      /* eslint-disable camelcase */
      return_scopes: true,
      /* eslint-enable camelcase */
    })
  }

  getUserData () {
    return new Promise(function(resolve, reject) {
      FB.api('/me', 'get', { fields: 'name,first_name,last_name,email' }, function(response) {
        if (!response || response.error) {
          reject(`Error occured. Response: ${response}`)
        } else {
          resolve(response)
        }
      })
    })
  }

  /**
   * Fills popup form with user FB data
   * 
   * @param {Object} user 
   */
  fillWithUserData (user) {
    const config = this.loginConfig
    for (const prop in config.formFields) {
      if (user.hasOwnProperty(prop)) {
        config.formFields[prop].value = user[prop]
      }
    }
  }

  runExternalMethods () {
    const externalMethods = this.loginConfig.methodsToCall
    if (externalMethods == null) return

    for (const method in externalMethods) {
      externalMethods[method]()
    }
  }

  prepareUserData () {
    this.getUserData()
      .then(user => this.fillWithUserData(user))
      .then(() => this.runExternalMethods())
      .catch(err => log.error(err))
  }
}



// WEBPACK FOOTER //
// ./src/services/FacebookService.js